import React, { useState } from 'react'
import PriceCard from './PriceCard';
import { Button, Card, Checkbox, Col, Divider, Modal, Row,Image } from 'antd';
import CommonCard, { colCardStyle, contentAreaStyle, outerCardStyle } from './CommonCard';



function Packages({ sessionData, packageData, selectedPackages, setSelectedPackages, selectedSessions, setSelectedSessions,selectedAddOns, ...props }) {
  const packages = packageData || [];

  const [openDetail, setOpenDetail] = useState(false);
  const [storedPackage, setStoredPackage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const toggleSelect = (packageItem) => {
    setSelectedPackages((prev) => {
      const exists = prev.find((s) => s.uuid === packageItem.uuid);
      if (exists) {
        return prev.filter((s) => s.uuid !== packageItem.uuid);
      }
      return [...prev, packageItem];
    });

    setSelectedSessions((prev) =>
      prev.filter(
        (session) =>
          !packageItem?.sessions?.some((pkgSession) => pkgSession.uuid === session.uuid)
      )
    );
  };

  return (
        <div style={outerCardStyle}>
      <div style={contentAreaStyle}>
        <Row gutter={[16, 16]}>
          {packages?.map((packageItem) => {
            const isSelected = selectedPackages?.some(
              (s) => s.uuid === packageItem.uuid
            );
            return (
              <Col xs={24} sm={24} md={24} lg={6} xl={6}  key={packageItem.uuid} style={colCardStyle}>
                <CommonCard
                  data={packageItem}
                  isSelected={isSelected}
                  toggleSelect={toggleSelect}
                  modelName="package"
                  setStoredPackage={setStoredPackage}
                  storedPackage={storedPackage}
                  setOpenDetail={setOpenDetail}
                  openDetail={openDetail}
                  setPreviewOpen={setPreviewOpen}
                  previewOpen={previewOpen}
                >
                </CommonCard>
              </Col>
            );
          })}
        </Row>
      </div>
      <div style={{ textAlign: 'left', alignSelf: 'flex-start', marginTop: 3 }}>
        <PriceCard packages={selectedPackages} sessions={selectedSessions} addons={selectedAddOns} />
      </div>
    </div>
  )
}

export default Packages